import {Box, Drawer, DrawerProps, SxProps, Theme} from '@mui/material';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import style from './style.module.scss';
import {t} from 'i18next';

const panelWidth = '66vw';
const panelHeight = '100%';

export type aurDrawerProps = DrawerProps & {
  drawerContent?: React.ReactNode;
  drawerHeader?: React.ReactNode;
  drawerRootSx?: SxProps<Theme>;
  ariaLabel?: string;
};

const AurDrawer = ({
  drawerContent,
  drawerHeader,
  drawerRootSx,
  ariaLabel = t('common.drawerPanel'), 
  ...rest
}: aurDrawerProps) => {
  const isLioOpen = useSelector(
    (state: RootState) => state.askLioSlice.isChatPanelVisible
  );

  return (
    <Drawer
      {...rest}
      sx={{
        '& .MuiDrawer-paper': {
          width: panelWidth,
          height: panelHeight,
        },
      }}
      PaperProps={{
        className: `${style.aurDrawerPaperPop} ${
          isLioOpen ? style.askLioPanelOpen : ''
        }`,
      }}
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel}
      disableEnforceFocus
    >
      <Box
        sx={{
          height: panelHeight,
          backgroundColor: (theme) => theme.palette.background.default,
          ...(drawerRootSx || {}),
        }}
      >
        {drawerHeader || null}
        {drawerContent || null}
      </Box>
    </Drawer>
  );
};

export default AurDrawer;
